/**
 * Finance report — "מה לכלול" section: status chips (square, "הכל" first),
 * chart toggles and section toggles. All state lives in the wizard hook.
 */

import { Check } from "@phosphor-icons/react";
import {
  FIN_STATUS_OPTIONS,
  FIN_CHART_OPTIONS,
  FIN_SECTION_OPTIONS,
  monthsInRange,
} from "./financeReportModel";

function ToggleRow({ label, checked, onChange, hint }) {
  return (
    <label className="prw-toggle-row">
      <span className="prw-toggle-label">
        {label}
        {hint && <span className="frx-toggle-hint"> · {hint}</span>}
      </span>
      <span className="prw-toggle">
        <input type="checkbox" checked={checked} onChange={onChange} />
        <span className="prw-toggle-slider" />
      </span>
    </label>
  );
}

function FinanceOptionsStep({ wiz }) {
  const {
    financeOptions,
    toggleFinanceStatus,
    setAllFinanceStatuses,
    toggleFinanceChart,
    toggleFinanceSection,
    startDate,
    endDate,
  } = wiz;
  const { statuses, charts, sections } = financeOptions;
  const allOn = FIN_STATUS_OPTIONS.every((s) => statuses.has(s.key));
  const multiMonth = monthsInRange(startDate, endDate) > 1;

  return (
    <div className="prw-step-panel">
      <div className="frx-group">
        <span className="frx-group-title">סטטוסים לכלול</span>
        <div className="frx-chips" role="group" aria-label="סטטוסים">
          <button
            type="button"
            className={`frx-chip ${allOn ? "active" : ""}`}
            onClick={() => setAllFinanceStatuses(!allOn)}
            aria-pressed={allOn}
          >
            {allOn && <Check size={12} weight="bold" />}
            הכל
          </button>
          {FIN_STATUS_OPTIONS.map((s) => {
            const on = statuses.has(s.key);
            return (
              <button
                key={s.key}
                type="button"
                className={`frx-chip ${on ? "active" : ""}`}
                style={on ? { "--chip-color": s.color } : undefined}
                onClick={() => toggleFinanceStatus(s.key)}
                aria-pressed={on}
              >
                <span className="frx-chip-dot" style={{ background: s.color }} />
                {s.label}
              </button>
            );
          })}
        </div>
        {statuses.size === 0 && (
          <div className="prw-field-error">יש לבחור לפחות סטטוס אחד</div>
        )}
      </div>

      <div className="frx-group">
        <span className="frx-group-title">גרפים</span>
        <div className="prw-toggle-list">
          {FIN_CHART_OPTIONS.map((c) => (
            <ToggleRow
              key={c.key}
              label={c.label}
              hint={c.multiMonthOnly && !multiMonth ? "מוצג רק בטווח של יותר מחודש" : null}
              checked={!!charts[c.key]}
              onChange={() => toggleFinanceChart(c.key)}
            />
          ))}
        </div>
      </div>

      <div className="frx-group">
        <span className="frx-group-title">טבלאות ומדדים</span>
        <div className="prw-toggle-list">
          {FIN_SECTION_OPTIONS.map((s) => (
            <ToggleRow
              key={s.key}
              label={s.label}
              checked={!!sections[s.key]}
              onChange={() => toggleFinanceSection(s.key)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default FinanceOptionsStep;
